import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

export interface PendingGuestSlice {
    email?: string;
    name?: string;
    surname?: string;
    isExternal?: boolean;
    start?: string;
    expiration?: string;
    vehicleTypeRef?: string;
}

const initialState: PendingGuestSlice = {
    email: '',
    expiration: '',
    name: '',
    start: '',
    surname: '',
};

const pendingGuestSlice = createSlice({
    initialState,
    name: 'pendingGuest',
    reducers: {
        clearPendingGuest: () => {
            return initialState;
        },
        setPendingGuest: (_, action: PayloadAction<PendingGuestSlice>) => action.payload,
        updatePendingGuestProps: (state, action: PayloadAction<PendingGuestSlice>) =>
            ({ ...state, ...action.payload }),
    },
});

export const { setPendingGuest, clearPendingGuest, updatePendingGuestProps } = pendingGuestSlice.actions;
export default pendingGuestSlice.reducer;